//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DivSpan from '@/components/DivSpan';
import searchInput from '@/components/search-input';
import fileUpload from '@/components/file-upload'



export default {
  name: "pur-requisition-demand",
  components: {DivSpan,searchInput,fileUpload},
  data() {
    return {
      list: [],
      searchDataList: [{field: "status", option: "IN", values:["APPROVE_FINISHED", "TO_SOURCING", "TO_ORDER", "FINISHED"]}],
      statusList: [],
      showMore: true,
      page: 0,
      codeSort: 'DESC'
    }
  },

  methods: {
    //获取全部状态列表
    getStautsList(){
      this.$get('api/dict-tables/search-with-list?dictCode=requisitionType').then((data) => {
        this.statusList = data.dictItems;
      })
    },
    onItemClick(code){
      if(code){
        this.searchDataList.push({field: "typeCode", option: "IN", values:[code], collectIndex: -1})
      }else{
        this.searchDataList=this.searchDataList.filter(val=>val.field!=='typeCode');
      }
      this.getList();
    },
    goFlow(requestId){
      this.$router.push('/workflow/'+requestId+'?component=PurRequisitionDrawerComponent')
    },
    getMore(){
      this.page++
      this.$loadingShow();
      let params;
      params={
        direction:this.codeSort,
        fromClientType:'h5',
        number: this.page,
        property:'createdDate',
        size: 10,
        rules:[],
        specialConditions:[]
      };
      if(this.searchDataList.length){
        params.rules=this.searchDataList;
      }
      this.$post('api/purRequisition/page',params ).then((data) => {
        this.list = this.list.concat(data.content);
        data.content.length<10?this.showMore=false:''
        this.$loadingHide();
      }).catch((error) => {
        this.$loadingHide();
      });
    },
    view(requestId) {
      this.$router.push('/workflow/'+requestId + '?component=LeaveMessageViewComponent')
    },
    searchPurCode(values) {
      this.searchDataList.push({field: "code", option: "LIKE_ANYWHERE", values:[values], collectIndex: -1})
      this.getList()
    },
    delPurCode(){
      this.searchDataList=this.searchDataList.filter(val=>val.field!=='code');
      this.getList()
    },
    searchMarker(values) {
      this.searchDataList.push({field: "purRequisitionMat.applicantName", option: "LIKE_ANYWHERE", values:[values], collectIndex: -1})
      this.getList()
    },
    delMarker(){
      this.searchDataList=this.searchDataList.filter(val=>val.field!=='purRequisitionMat.applicantName');
      this.getList()
    },
    searchMaterial(values) {
      this.searchDataList.push({field: "matName", option: "LIKE_ANYWHERE", values:[values], collectIndex: -1})
      this.getList()
    },
    delMaterial(){
      this.searchDataList= this.searchDataList.filter(val=>val.field!=='matName');
      this.getList()
    },

    //获取列表
    getList() {
      this.$loadingShow();
      let params;
      params={
        direction:this.codeSort,
        fromClientType:'h5',
        number: 0,
        property:'createdDate',
        size: 10,
        rules:[],
        specialConditions:[]
      };
      if(this.searchDataList.length){
        params.rules=this.searchDataList;
      }
      this.$post('api/purRequisition/page',params ).then((data) => {
        this.list = data.content;
        data.content.length<10?this.showMore=false:''
        this.$loadingHide();
      }).catch((error) => {
        this.$loadingHide();
      });
    },


  },
  mounted() {
    this.getList()
    this.getStautsList();

  },


}



// WEBPACK FOOTER //
// ./src/page/purchase-requisition/pur-requisition-demand.vue